import {SERVER_GG_STORE_REPLY} from '../../constans/index';
import {
    GAME_CREATE_REQUEST,
    GAME_CREATE_SUCCESS,
    GAME_CREATE_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const CreateGameAction = (data_target) => ({

    [RSAA]: {
        endpoint: `${SERVER_GG_STORE_REPLY}/api/games`,
        method: 'POST',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(data_target);
        }),
        types: [
            GAME_CREATE_REQUEST,
            {
                type: GAME_CREATE_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": GAME_CREATE_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: GAME_CREATE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": GAME_CREATE_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {CreateGameAction}